import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  BooleanField,
  FunctionField,
  TopToolbar,
  EditButton,
  DeleteButton,
  ListButton,
} from 'react-admin';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { formatDuration } from '../../utils/formatDuration';

const ShowActions = () => (
  <TopToolbar>
    <ListButton />
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

const DurationField = ({ record }: { record?: any }) => {
  if (!record?.estimatedDuration) {
    return <span>-</span>;
  }

  return <span>{formatDuration(record.estimatedDuration)}</span>;
};

const ConfigurationBreadcrumbs = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/configuration')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Configuration
        </Link>
        <Link
          underline="hover"
          color="inherit"
          onClick={() => navigate('/crm/service-blueprints')}
          sx={{ cursor: 'pointer', '&:hover': { color: '#1976d2' } }}
        >
          Service Blueprints
        </Link>
        <Typography color="text.primary">Details</Typography>
      </Breadcrumbs>
    </Box>
  );
};

export const ServiceBlueprintShow = () => {
  return (
    <Show actions={<ShowActions />}>
      <SimpleShowLayout>
        <ConfigurationBreadcrumbs />
        <TextField source="name" label="Name" />
        <TextField source="description" label="Description" />
        <NumberField
          source="basePrice"
          label="Base Price"
          options={{ style: 'currency', currency: 'USD' }}
        />
        <FunctionField
          source="estimatedDuration"
          label="Duration"
          render={(record: any) => <DurationField record={record} />}
        />
        <BooleanField source="active" label="Active" />
        <BooleanField source="taxable" label="Taxable" />
        <TextField source="qbAccountRef" label="QuickBooks Account Reference" />
      </SimpleShowLayout>
    </Show>
  );
};
